import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCurrentPage,
  getApiParams,
} from "../../../NetworkPortal/ProviderProfileDetails/helper";
import { useEffect } from "react";
import {
  CSVData,
  TestExcelHeader,
  TestExcelHeaderColmns,
  initialFilterState,
  initialHeaderTest,
} from "./helper";
import Modal from "react-modal";
import Select from "react-select";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import { ChooseToFilterTestPopup } from "./ChooseToFilterTestPopup";
import { AddQuicklyTestSKUPopup } from "./AddQuicklyTestSKUPopup";
import PaginatedItems from "../../../../common/Pagination";
import { CSVLink } from "react-csv";
import {
  getSkuTestPackagesNetworkAction,

} from "../../../../redux/actions/TestPackageNetworkAction";
import { getNetworkMenuId, getToken } from "../../../../Utils/types";
import { UploadExcelTestNetworkPopup } from "./UploadExcelTestNetworkPopup";
import { API_URL_WITHOUT_USER } from "../../../../Utils/API";
import { isLoadingAction } from "../../../../Utils/helper";

const Test = ({selectTestPackages}) => {
  const dispatch = useDispatch();
  const [showHeaderTestArray, setShowHeaderTestArray] =
    useState(initialHeaderTest);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [isUploadExcel, setIsUploadExcel] = useState(false);
  const [providerCanEdit,setProviderCanEdit] = useState(null)
  const [searchFilter, setSearchFilter] = useState(initialFilterState);
  const [isAddSku, setIsAddSku] = useState(false);
  const [isChooseToFilter, setIsChooseToFilter] = useState(false);
  const [userDetail, setUserDetail] = useState(null);

  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });

  useEffect(() => {
    let value = getNetworkMenuId()?.informationPermissions.filter((ele)=> ele?.informationName === selectTestPackages)
    setProviderCanEdit(value[0])
  }, [selectTestPackages]);
  
 
  useEffect(() => {
    dispatch(
      getSkuTestPackagesNetworkAction({ ...searchFilter, ...apiParams,serviceName : selectTestPackages === "SKU & Vaccination" ? "" :selectTestPackages })
    );
  }, [globalReducer?.getCurrentPage]);

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    dispatch(
      getSkuTestPackagesNetworkAction({
        ...searchFilter,
        ...apiParams,
        page: 1,
        serviceName : selectTestPackages === "SKU & Vaccination" ? "" :selectTestPackages
      })
    );
  };

  const handleClearFilter = () => {
    setSearchFilter(initialFilterState);
    dispatch(getSkuTestPackagesNetworkAction({...initialFilterState,serviceName : selectTestPackages === "SKU & Vaccination" ? "" :selectTestPackages}));
    clearCurrentPage(dispatch);
    // setMultiSelect([]);
    // setSelectAll(false);
  };
  const ExportToExcelHandler = (ele) => {
    isLoadingAction(true, dispatch);
    setIsLoadingExcel(true);
    const url = `${API_URL_WITHOUT_USER}/NetworkSkuPackage/ExportToExcelSKUDetailsNetwork`;
    let data = {
      facilityId: searchFilter?.facilityId,
      providerId: searchFilter?.providerId,
      sortDirection: "desc",
      serviceName : selectTestPackages === "SKU & Vaccination" ? null :selectTestPackages
      // providerFacilitiesIds: selectAll ? "" : multiSelect?.toString(),
    }
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => 
        response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "ProviderSkuDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
        // isLoadingAction(false, dispatch);
      });
  };
 

  const EditIconHandler = (ele) => {
    setIsAddSku(true);
    setUserDetail(ele);
  };
 
  return (
    <>
      <div className="row-filter">
        <Select
          className="basic-multi-select custom-width-300"
          classNamePrefix="select"
          placeholder="Search HA SKU Name or Code"
          name="colors"
          isClearable={true}
          options={providerPortalDetailReducer?.getFacilityReason?.map(
            (ele) => {
              return {
                value: ele?.facilityId,
                label: ele?.facilityName,
              };
            }
          )}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          onChange={(e) => {
            setSearchFilter({
              ...searchFilter,
              facilityId: e === null ? 0 : e?.value,
              facilityName: e === null ? e : e?.label,
            });
          }}
          value={
            searchFilter?.facilityId
              ? {
                  value: searchFilter?.facilityId,
                  label: searchFilter?.facilityName,
                }
              : null
          }
        />
        <Select
          className="basic-multi-select custom-width-300"
          classNamePrefix="select"
          placeholder="Search Provider Name or Code"
          name="colors"
          isClearable={true}
          options={TestPackageReducer?.getProviderListNetworkDetails?.map(
            (ele) => {
              return {
                value: ele?.providerId,
                label: ele?.providerName,
              };
            }
          )}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          onChange={(e) => {
            setSearchFilter({
              ...searchFilter,
              providerId: e === null ? 0 : e?.value,
              providerName: e === null ? e : e?.label,
            });
          }}
          value={
            searchFilter?.providerId
              ? {
                  value: searchFilter?.providerId,
                  label: searchFilter?.providerName,
                }
              : null
          }
        />
        <div className="search" type="button" onClick={handleSearch}>
          <a className="sidebar-links">
            <SearchIcon />
            <span className="sidebar-link-text">Search</span>
          </a>
        </div>
        <div className="search" type="button" onClick={handleClearFilter}>
          <a className="sidebar-links">
            <span className="sidebar-link-text">Clear All</span>
          </a>
        </div>
      </div>
      <div className="row-results">
        <div className="d-flex gap-10">
          <select
            className="row-selectdropdown"
            value={searchFilter?.rows}
            onChange={(e) => {
              clearCurrentPage(dispatch);
              setSearchFilter({
                ...searchFilter,
                page: 1,
                rows: e.target.value,
              });
              dispatch(
                getSkuTestPackagesNetworkAction({
                  ...searchFilter,
                  rows: e.target.value,
                  page: 1,
                  serviceName : selectTestPackages === "SKU & Vaccination" ? "" :selectTestPackages
                })
              );
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
          <p className="results">
            Total <span>{globalReducer?.getTotalCount}</span> results
          </p>
        </div>
        {/* <div>
          {multiSelect?.length ? (
            <div className="select_all_div">
              {!selectAll && (
                <>
                  <p>{multiSelect?.length} tests are selected</p>
                  <span
                    className="select_all_primary_cases"
                    onClick={() => setSelectAll(true)}
                  >
                    Select all {globalReducer?.getTotalCount} tests
                  </span>
                </>
              )}
              {selectAll && (
                <p>{globalReducer?.getTotalCount} tests are selected</p>
              )}
            </div>
          ) : null}
        </div> */}
        <div className="d-flex gap-10">
          {providerCanEdit?.canEdit && (
            <button
              className={`btn search__btn`}
              type="button"
              onClick={() => {
                setIsAddSku(true);
                setUserDetail(null);
              }}
            >
              <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
              {window.innerWidth <= 700 ? "Add" : "Quickly Add SKUs"}
            </button>
          )}
          <button
            className={`btn ${
              !isLoadingExcel ? "search__btn" : "disabled_btn"
            }`}
            
            type="button"
            onClick={!isLoadingExcel && ExportToExcelHandler}
            // disabled={!multiSelect?.length}
          >
            <i className="fa-solid fa-arrow-down"></i>&nbsp;
            {isLoadingExcel
              ? window.innerWidth <= 700
                ? "Export"
                : "Exporting..."
              : window.innerWidth <= 700
              ? "Excel"
              : "Export To Excel"}
          </button>
          
          {/* <CSVLink
            style={{ display: "none" }}
            id="exportexcel"
            data={CSVData(excelSheetData)}
            headers={TestExcelHeader}
            filename={"providerSKUtestdetails.csv"}
          ></CSVLink> */}
          {providerCanEdit?.canEdit &&  <button
            className={`btn search__btn`}
            type="button"
            onClick={() => setIsUploadExcel(true)}
          >
            <i className="fas fa-file-upload pt-1"></i>&nbsp;
            {window.innerWidth <= 700 ? "Import" : "Import SKU"}
          </button>}
        </div>
      </div>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              {/* <th>
                <input
                  type="checkbox"
                  onClick={(e) =>
                    e?.target?.checked
                      ? (setSelectAll(false),
                        setMultiSelect([
                          ...new Set(
                            [
                              ...multiSelect,
                              ...TestPackageReducer?.getSkuTestPackagesDetails?.lstSKUDetails?.map(
                                (ele) => {
                                  return ele?.changedemoId;
                                }
                              ),
                            ].map((item) => item)
                          ),
                        ]))
                      : (setSelectAll(false),
                        setMultiSelect(
                          multiSelect?.length === 10
                            ? []
                            : multiSelect?.filter(
                                (item) => !providerFacilitiesIds.includes(item)
                              )
                        ))
                  }
                  checked={providerFacilitiesIds?.every((r) => multiSelect?.includes(r))}
                  className="form-check-input"
                  readOnly
                />
              </th> */}
              {showHeaderTestArray?.map((ele, index) => {
                return (
                  <th scope="col" key={index}>
                    {ele}
                  </th>
                );
              })}
              <th
                style={{ cursor: "pointer" }}
                onClick={() => setIsChooseToFilter(true)}
              >
                <img src="./../images/settings.png" />
              </th>
            </tr>
          </thead>
          <tbody>
            {TestPackageReducer?.getSkuTestPackagesDetails?.lstSKUDetails?.map(
              (ele, index) => {
                return (
                  <tr key={index}>
                    {/* <td>
                      <input
                        type="checkbox"
                        onClick={(e) =>
                          e?.target?.checked
                            ? (setSelectAll(false),
                              setMultiSelect([...multiSelect, ele?.changedemoId]))
                            : (setSelectAll(false),
                              setMultiSelect(
                                multiSelect.filter(
                                  (value) => value !== ele?.changedemoId
                                )
                              ))
                        }
                        checked={multiSelect?.some(
                          (element) => element === ele?.changedemoId
                        )}
                        className="form-check-input"
                        readOnly
                      />
                    </td> */}
                    {showHeaderTestArray?.map((col) => (
                      <td>
                        {col === "Outsourced"
                          ? ele.isOutSourced
                            ? "Yes"
                            : "No"
                          : ele[TestExcelHeaderColmns[col]] === null
                          ? "-"
                          : ele[TestExcelHeaderColmns[col]]}
                      </td>
                    ))}
                    <td
                      style={{
                        cursor: !providerCanEdit?.canEdit
                          ? "default"
                          : "pointer",
                      }}
                      onClick={() =>
                        !providerCanEdit?.canEdit
                          ? null
                          : EditIconHandler(ele)
                      }
                    >
                      <img src="./../images/edit-icon.png" />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination-row">
        {globalReducer?.getTotalCount !== 0 && (
          <PaginatedItems
            totalCount={globalReducer?.getTotalCount}
            perPageData={searchFilter?.rows}
          />
        )}
      </div>
      <Modal
        isOpen={isAddSku}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <AddQuicklyTestSKUPopup
          setIsAddSku={setIsAddSku}
          searchFilter={searchFilter}
          apiParams={apiParams}
          userDetail={userDetail}
          selectTestPackages={selectTestPackages}
        />
      </Modal>
      <Modal
        isOpen={isChooseToFilter}
        className="modal-add-user-popup modal-role-user-popup modal-choose-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ChooseToFilterTestPopup
          setIsChooseToFilter={setIsChooseToFilter}
          showHeaderTestArray={showHeaderTestArray}
          setShowHeaderTestArray={setShowHeaderTestArray}
        />
      </Modal>
      <Modal
        isOpen={isUploadExcel}
        className="modal-add-user-popup modal-upload-excel-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <UploadExcelTestNetworkPopup setIsUploadExcel={setIsUploadExcel} />
      </Modal>
    </>
  );
};

export default Test;
